module.exports = __webpack_public_path__ + "static/media/sports_13.984fbc42.jpg";